import { createSlice } from "@reduxjs/toolkit";

const CategoriesSlice = createSlice({
  name: "Category",
  initialState: {
    Categories: [],
    Categoriesitems: [],
  },
  reducers: {
    setCategory: (state, action) => {
      state.Categories = action.payload;
         },
    setCategoryitems: (state, action) => {
      state.Categoriesitems = action.payload
        ;
    },
  },
});

export const { setCategory, setCategoryitems } = CategoriesSlice.actions;

export default CategoriesSlice.reducer;
